import React from "react";
import "./header.css";

const Header = () => (
  <header className="masthead d-flex">
    <div className="container text-center my-auto">
      <small>It's pronounced "shoe" <span role="img" aria-label='shoe'>👞</span></small>
      <h1 className="mb-1">Hi, I'm Dan Hsu</h1>
      <h3 className="mb-5">
        <em>I'm a full-stack developer based in LA</em>
      </h3>
      <h4>
        With over 4 years of experience in software engineering
      </h4>
      <h4>
        Let me use my skills to turn your dreams into reality
      </h4>
      <a className="btn btn-xl js-scroll-trigger headerButt mt-3" href="#portfolio">
        See some of my projects
      </a>
    </div>
    <div className="overlay" />
  </header>
);
export default Header;
